import { Component, OnInit } from '@angular/core';
import {ModalKendo} from "../../../lib/ModalKendo";

interface CampoApi {
  campo: string;
  valor: string;
  tipo: string;
  observacao: string;
  vazio: boolean;
  nivel: number;
  filhos: CampoApi[];
  expandido: boolean;
}

interface GrupoApi {
  titulo: string;
  campos: CampoApi[];
  expandido: boolean;
}

@Component({
  selector: 'app-payload-json-view',
  templateUrl: './payload-json-view.component.html',
  styleUrls: ['./payload-json-view.component.scss']
})
export class PayloadJsonViewComponent extends ModalKendo implements OnInit {
  payload: any;
  mensagemCopiada: string;
  titulo = 'JSON Pedido'
  descricao = '';
  emTabela = false;
  campos: Array<{campo: string, valor: string}> = [];
  dadosApi = false;
  canal = '';
  consultadoEm: Date;
  busca = '';
  filtro = 'todos';
  abaAtiva = 'pedido';
  abas = [
    {id: 'pedido', titulo: 'Pedido', icone: 'fa-file-alt'},
    {id: 'canal', titulo: 'Canal e loja', icone: 'fa-store'},
    {id: 'itens', titulo: 'Itens', icone: 'fa-box'},
    {id: 'valores', titulo: 'Valores', icone: 'fa-dollar-sign'},
    {id: 'metadados', titulo: 'Metadados', icone: 'fa-cog'},
    {id: 'json', titulo: 'JSON completo', icone: 'fa-code'}
  ];
  grupos: {[aba: string]: GrupoApi[]} = {};
  private descricoes: {[campo: string]: string} = {
    id: 'Identificador', displayId: 'Número exibido pelo parceiro', status: 'Status retornado pelo parceiro',
    type: 'Tipo', name: 'Nome', externalCode: 'Código externo', unit: 'Unidade de medida',
    quantity: 'Quantidade', unitPrice: 'Preço unitário', totalPrice: 'Preço total',
    optionsPrice: 'Preço de opções e adicionais', value: 'Valor', currency: 'Moeda',
    specialInstructions: 'Instruções especiais', options: 'Opções e adicionais',
    merchant: 'Loja no parceiro', salesChannel: 'Canal de venda', customer: 'Cliente',
    delivery: 'Entrega', takeout: 'Retirada', items: 'Itens do pedido', total: 'Totais',
    payments: 'Pagamentos', methods: 'Formas de pagamento', method: 'Método de pagamento',
    pending: 'Valor pendente', prepaid: 'Valor pago antecipadamente', cash: 'Pagamento em dinheiro',
    changeFor: 'Troco para', orderAmount: 'Total do pedido', itemsPrice: 'Total dos itens',
    deliveryFee: 'Taxa de entrega', serviceFee: 'Taxa de serviço', discount: 'Desconto',
    createdAt: 'Data de criação', orderTiming: 'Momento do pedido', extraInfo: 'Informações adicionais'
  };
  constructor(  ) {
    super()
  }

  ngOnInit(): void {
    if(typeof this.payload === 'string')
      this.payload = JSON.parse(this.payload)
    if(this.dadosApi) this.prepareDadosApi();
    else if(this.emTabela) this.adicioneCampos(this.payload, '');
  }

  get jsonCompleto(): string {
    return JSON.stringify(this.payload, null, 2);
  }

  get parceiroAiqfome(): boolean {
    return ['aiqfome', 'aiquefome'].indexOf(String(this.canal).toLowerCase().trim()) >= 0;
  }

  get resumo(): {tipo: string, status: string, pedido: string, loja: string} {
    const pedido = this.payload || {};
    const texto = (valor: any) => typeof valor === 'string' || typeof valor === 'number' ? String(valor) : '';
    return {tipo: texto(pedido.type), status: texto(pedido.status), pedido: texto(pedido.id),
      loja: texto(pedido.merchant && (pedido.merchant.name || pedido.merchant.id))};
  }

  private prepareDadosApi(): void {
    this.grupos = {};
    for(const aba of this.abas) this.grupos[aba.id] = [];
    if(this.payload === null || typeof this.payload !== 'object' || Array.isArray(this.payload)) {
      this.grupos.pedido.push({titulo: 'Dados retornados', campos: [this.crieCampo(this.payload, '$', '', 0)], expandido: true});
      return;
    }
    const secoes: {[chave: string]: string} = {
      id: 'pedido', displayId: 'pedido', status: 'pedido', type: 'pedido', createdAt: 'pedido',
      orderTiming: 'pedido', preparationStartDateTime: 'pedido', customer: 'pedido', delivery: 'pedido',
      takeout: 'pedido', indoor: 'pedido', schedule: 'pedido', extraInfo: 'pedido',
      merchant: 'canal', salesChannel: 'canal', items: 'itens', total: 'valores', payments: 'valores',
      discounts: 'valores', benefits: 'valores', fees: 'valores'
    };
    for(const chave of Object.keys(this.payload)) {
      const aba = Object.prototype.hasOwnProperty.call(secoes, chave) ? secoes[chave] : 'metadados';
      if(chave === 'items' && Array.isArray(this.payload.items) && this.payload.items.length) {
        this.grupos.itens = this.payload.items.map((item: any, indice: number) => {
          const campo = this.crieCampo(item, `items[${indice}]`, 'items', 0);
          return {titulo: `Item ${indice + 1}${item && item.name ? ' — ' + item.name : ''}`,
            campos: campo.filhos.length ? campo.filhos : [campo], expandido: true};
        });
      } else {
        if(!this.grupos[aba].length)
          this.grupos[aba].push({titulo: this.abas.find(item => item.id === aba).titulo, campos: [], expandido: true});
        this.grupos[aba][0].campos.push(this.crieCampo(this.payload[chave], chave, chave, 0));
      }
    }
  }

  private crieCampo(valor: any, caminho: string, chave: string, nivel: number): CampoApi {
    const tipo = valor === null ? 'null' : Array.isArray(valor) ? 'array' : typeof valor;
    const campos = valor !== null && typeof valor === 'object' ? Object.keys(valor) : [];
    return {
      campo: caminho, tipo, nivel, expandido: nivel < 2,
      observacao: Object.prototype.hasOwnProperty.call(this.descricoes, chave) ? this.descricoes[chave] : '',
      vazio: valor == null || valor === '' || (tipo === 'object' || tipo === 'array') && !campos.length,
      valor: valor == null || tipo === 'object' || tipo === 'array' ? '' :
        typeof valor === 'string' ? valor : JSON.stringify(valor),
      filhos: campos.map(nome => this.crieCampo(valor[nome], tipo === 'array' ? `${caminho}[${nome}]` :
        `${caminho}.${nome}`, nome, nivel + 1))
    };
  }

  selecioneAba(aba: string): void {
    this.abaAtiva = aba;
    this.busca = '';
    this.filtro = 'todos';
  }

  private folhas(campos: CampoApi[]): CampoApi[] {
    return campos.reduce((todos: CampoApi[], campo) => todos.concat(
      campo.filhos.length ? this.folhas(campo.filhos) : [campo]), []);
  }

  contagem(aba: string, filtro = 'todos'): number {
    return (this.grupos[aba] || []).reduce((total, grupo) => total + this.folhas(grupo.campos)
      .filter(campo => filtro === 'todos' || (filtro === 'vazios' ? campo.vazio : !campo.vazio)).length, 0);
  }

  get quantidades(): {todos: number, preenchidos: number, vazios: number} {
    return {todos: this.contagem(this.abaAtiva), preenchidos: this.contagem(this.abaAtiva, 'preenchidos'),
      vazios: this.contagem(this.abaAtiva, 'vazios')};
  }

  private corresponde(campo: CampoApi, buscaHerdada = false): boolean {
    const busca = this.busca.trim().toLocaleLowerCase();
    return (buscaHerdada || !busca || [campo.campo, campo.valor, campo.observacao].join(' ').toLocaleLowerCase().includes(busca)) &&
      (this.filtro === 'todos' || (this.filtro === 'vazios' ? campo.vazio : !campo.vazio));
  }

  linhas(grupo: GrupoApi): CampoApi[] {
    const filtrando = !!this.busca.trim() || this.filtro !== 'todos';
    const visiveis = (campos: CampoApi[], buscaHerdada = false): CampoApi[] => campos.reduce((todos: CampoApi[], campo) => {
      if(filtrando) {
        const busca = this.busca.trim().toLocaleLowerCase();
        const filhos = visiveis(campo.filhos, buscaHerdada || !!busca &&
          [campo.campo, campo.valor, campo.observacao].join(' ').toLocaleLowerCase().includes(busca));
        if(filhos.length || (!campo.filhos.length && this.corresponde(campo, buscaHerdada)))
          todos.push(campo, ...filhos);
      } else {
        todos.push(campo);
        if(campo.expandido) todos.push(...visiveis(campo.filhos));
      }
      return todos;
    }, []);
    return visiveis(grupo.campos);
  }

  get gruposVisiveis(): GrupoApi[] {
    return (this.grupos[this.abaAtiva] || []).filter(grupo => this.linhas(grupo).length > 0);
  }

  get filtrando(): boolean {
    return !!this.busca.trim() || this.filtro !== 'todos';
  }

  baixeJson(): void {
    const url = URL.createObjectURL(new Blob([this.jsonCompleto], {type: 'application/json;charset=utf-8'}));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'dados-pedido-api.json';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  private adicioneCampos(valor: any, caminho: string): void {
    if(valor !== null && typeof valor === 'object' && Object.keys(valor).length) {
      for(const chave of Object.keys(valor)) {
        const campo = Array.isArray(valor) ? `${caminho}[${chave}]` :
          (caminho ? `${caminho}.${chave}` : chave);
        this.adicioneCampos(valor[chave], campo);
      }
    } else {
      this.campos.push({campo: caminho || '$', valor: typeof valor === 'string' ? valor : JSON.stringify(valor)});
    }
  }

  copieJson(){
    let val = this.dadosApi ? this.jsonCompleto : JSON.stringify(this.payload);

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    let copiado = false;
    try {
      copiado = document.execCommand('copy');
    } catch(erro) {
      copiado = false;
    } finally {
      document.body.removeChild(selBox);
    }

    this.mensagemCopiada = copiado ? 'Dados copiados.' : 'Não foi possível copiar. Use o botão Baixar JSON.';

    setTimeout( () => {
      delete this.mensagemCopiada
    }, 5000);
  }
}
